export default __webpack_public_path__ + "static/media/Angle-small-right.fceaf914.svg";